import { Arrange, Box, Button, Icon, Typography } from "@fullscript/aviary-web";
import { faCheck } from "@fullscript/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./ContinuityStoreDeflection.styles";

interface Props {
  deflectionUrl: string;
}

const ContinuityStoreDeflection = ({ deflectionUrl }: Props) => {
  const { t } = useTranslation();

  const handleContinue = () => {
    window.location.href = deflectionUrl;
  };

  return (
    <Box customCss={styles.container} data-testid="continuity-store-deflection">
      <Typography variant="h3" customCss={styles.title} intention="neutral" colorIntensity="bold">
        {t(l.signIn.continuityStore.title)}
      </Typography>
      <Typography variant="body" customCss={styles.description}>
        {t(l.signIn.continuityStore.description)}
      </Typography>
      <div css={styles.benefits}>
        <Arrange alignment="center" gap="small" isWrapped={false}>
          <Icon icon={faCheck} />
          <Typography variant="body">{t(l.signIn.continuityStore.benefit1)}</Typography>
        </Arrange>
        <Arrange alignment="center" gap="small" isWrapped={false}>
          <Icon icon={faCheck} />
          <Typography variant="body">{t(l.signIn.continuityStore.benefit2)}</Typography>
        </Arrange>
      </div>
      <Button onClick={handleContinue} isFullWidth>
        {t(l.signIn.continuityStore.continueButton)}
      </Button>
    </Box>
  );
};

export { ContinuityStoreDeflection };
